import { ChartRange, DateRange } from '/src/lib/types';

/**
 * Range
 */

export type RangeProps = ChartRange;

export class Range implements RangeProps {
  values: DateRange;
  type: string;

  constructor(values: DateRange, type = 'range') {
    this.values = values;
    this.type = type;
  }
}
